import { render, staticRenderFns } from "./languageSelector.vue?vue&type=template&id=f71ea4a4"
import script from "./languageSelector.vue?vue&type=script&lang=ts"
export * from "./languageSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports